module.exports = __webpack_public_path__ + "static/img/claim_rewards@2x.0d85f569.png";